import React, { useState, useEffect } from "react"

import Index from "../components/pages"
import Question from "../components/pages/question"
import Answer from "../components/pages/answer"
import Result from "../components/pages/result"
import textData from "../data/textData"
import "../components/style.css"
import { Helmet } from "react-helmet"
import Loading from "../components/pages/loading"

let resultList: boolean[] = [
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
]

const IndexPage = () => {
  const [isLoad, setLoad] = useState(true)
  const [start, setStart] = useState(false)
  const [index, setIndex] = useState(0)
  const [view, setView] = useState("Question")

  const randomSort = () => {
    for (var i = textData.length - 1; i > 0; i--) {
      var r = Math.floor(Math.random() * (i + 1))
      var tmp = textData[i]
      textData[i] = textData[r]
      textData[r] = tmp
    }
  }
  useEffect(() => {
    randomSort()
  }, [])

  const toIndex = () => {
    resultList = [null, null, null, null, null, null, null, null, null, null]
    setIndex(0)
    setView("Question")
    setStart(false)
    randomSort()
  }
  const toQuestion = () => {
    setIndex(index + 1)
    setView("Question")
  }
  const toAnswer = choice => {
    resultList[index] = choice
    setView("Answer")
  }
  const toResult = () => {
    setView("Result")
  }
  const Props = {
    index: index,
    resultList: resultList,
    toIndex: toIndex,
    toQuestion: toQuestion,
    toAnswer: toAnswer,
    toResult: toResult,
  }

  let View: JSX.Element
  switch (view) {
    case "Question":
      View = <Question {...Props} />
      break
    case "Answer":
      View = <Answer {...Props} />
      break
    case "Result":
      View = <Result {...Props} />
      break
  }

  return (
    <>
      <Helmet>
        <title>ジャパンライダーズ検定</title>
        <html lang="ja" />
      </Helmet>
      {isLoad && <Loading setLoad={setLoad} />}
      {!isLoad && (
        <>
          {!start && <Index setStart={setStart} />}
          {start && <>{View}</>}
        </>
      )}
    </>
  )
}

export default IndexPage
